<template>
  <div class="order-list-page">
    <TopNavbar title="我的订单"></TopNavbar>
    <div class="list-box">
      <List
          v-model="loading"
          :finished="finished"
          finished-text="没有啦 好空啊"
          loading-text=" "
          @load="onLoad"
      >
        <div class="list" v-for="order in orderList" :key="order.id">
          <div v-for="(orderGroup, idx) in order.order_item_group " :key="idx" class="order-item-group">
            <card v-for="item in orderGroup.order_items"
                  :key="item.good_info.id"
                  :title="orderItemTitle(item)"
                  :desc="item.order_item_description"
                  :num="item.order_count"
                  :thumb="item.order_product_image_url" @click="goGood(item.good_info)">
              <template #footer>
                <div v-if="order.status==='closed'">
                  <Button size="mini" plain type="warning" round style="margin-top: 5px;" @click.stop="onToRemark(item.good_info.id)">去评价</Button>
                </div>
              </template>
            </card>
            <cell v-if="orderGroup.ship_info && orderGroup.ship_info.ship_id" class="cell-info">
              <div class="ship-cell-container">
                <div class="ship-cell">
                  <div class="info-div">
                    {{orderGroup.ship_info.ship_by}} :
                  </div>
                  <div class="info-div">
                    {{orderGroup.ship_info.ship_id}}
                  </div>
                </div>
                <div class="ship-info-button-container">
                  <Button class="copy-button"  size="small" @click="onClickShipStatus(order.address, orderGroup.ship_info)"> 查看物流
                  </Button>
                </div>
              </div>
            </cell>
            <cell v-else class="cell-info">
            </cell>
          </div>
          <cell-group>
            <cell class="cell-info">
              <div class="addr-cell">{{addressOrder(order)}}</div>
            </cell>

            <cell style="color:#808080" :value="'合计：￥'+formatPrice(order.total_price)" class="cell-info">
              <template slot="title">
                <div>{{parseTime(order.create_time)}}</div>
              </template>
            </cell>

            <cell class="cell-info">
              <div class="pay-container">
                <div class="desc-text">{{orderDesc(order)}}</div>
                <Button v-if="showPay(order)" @click="payOrder(order)" type="warning" class="pay-btn" size="mini" plain round> 支付</Button>
                <div v-else>
                  <div class="more-container" @click="onClickMore(order)">
                    <icon-svg icon-class="more"></icon-svg>
                  </div>
                </div>
              </div>
            </cell>
          </cell-group>
        </div>
      </List>
    </div>
    <ActionSheet v-model="showActions"  :actions="actions"  :round="false" cancel-text="取消" close-on-click-action @select="onSelect" style="z-index:10000"></ActionSheet>
    <Popup position="bottom" v-model="showConfirmPay"
           closeable
           close-icon="close"
           :close-on-popstate="true"
           :close-on-click-overlay="false"
    >
      <PayCardGoods
          :orderId="selectedOrderId"
          :orderType="selectedOrderType"
          :callbackUrl="callbackUrl"
          :addressInfo="selectedOrderAddr"
          :orderPrice="selectedOrderPrice"
      ></PayCardGoods>
    </Popup>
    <MpPopupCard scene="ship_info"></MpPopupCard>
  </div>
</template>

<script>
  import {Button, Card, Cell, CellGroup, List, Panel, Tag, Toast, ActionSheet, Popup} from "vant"
  import TopNavbar from "../common/TopNavbar";
  import PayCardGoods from "../common/PayCardGoods";
  import MpPopupCard from "../common/MpPopupCard";

  export default {
    name: "OrderListPage",
    components: {
      MpPopupCard,
      ActionSheet, Popup, PayCardGoods, TopNavbar, Button, Tag, CellGroup, Cell, Panel, Card, List
    },
    data() {
      return {
        orderList: [],
        loading: true,
        finished: false,
        offset: 0,
        count: 10,

        showConfirmPay: false,
        selectedOrderType: "",
        selectedOrderId: 0,
        selectedOrderPrice: 0,
        callbackUrl: "",
        selectedOrderAddr: {},

        showActions: false,
        actions: [{ name: '客服' }],
      };
    },
    mounted() {
      this.onLoad()
    },
    activated(){
      this.showActions = false
    },
    methods: {
      async onLoad() {
        let params = {
          offset: this.offset,
          count: this.count,
        }
        await this.$store.dispatch("GetOrderGoodList", params).then(result => {
          if (result.code === 20010) {
            let query = this.$route.query
            query._back = "order_list"
            this.$router.push({
              "path": "login",
              "query": query,
            })
          } else if (result.code === 0) {
            this.orderList.push(...result.data)
            this.offset = result.extra.max_cursor
            if (!result.extra.has_more) {
              this.finished = true
            }
          }
        }).catch(error => {
          Toast("网络错误")
          this.finished = true
        })
        this.loading = false
      },
      onToRemark(goodId) {
        this.$router.push("/goods_remark_create/" + goodId)
      },
      goGood(item) {
        this.$router.push('/good/' + item.id);
      },
      formatPrice(price) {
        return price.toFixed(2);
      },
      parseTime(timeS) {
        var date = new Date(timeS * 1000); //如果date为13位不需要乘1000
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        var D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' ';
        var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
        var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
        var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
        return Y + M + D + h + m + s;
      },

      orderDesc(order) {
        if (!order) {
          return ""
        }
        if (order.status === "finished") {
          return "待发货"
        } else if (order.status === "shipped") {
          return "已发货"
        } else if (order.status === "canceled") {
          return "已失效"
        } else if (order.status === "created") {
          return "待付款"
        } else if (order.status === "closed") {
          return "已完成"
        }
      },

      onSelect(item) {
        this.showActions = false
        if(item.name === "客服") {
          this.onToFeedback()
        } else if (item.name === "申请退款") {
          this.onToFeedback()
        }
      },

      onToFeedback() {
        this.$router.push("/message")
      },

      orderItemTitle(item) {
        let t = item.good_info.title.substr(0, 10)
        let s = item.good_info.sku_info_list
        if (s && s.length > 0) {
          t = t + s[0].property_desc
        }
        return t
      },
      addressOrder(order) {
        let addr = order.address
        if (!addr) {
          return ""
        }
        return "" + addr.name + " " + addr.tel + " " + addr.province + " " + addr.city + " " + addr.county + " " + addr.address_detail
      },

      onClickShipStatus(address, shipInfo) {
        let params= {
          ship_id: shipInfo.ship_id,
          ship_by: shipInfo.ship_by,
        }
        if (address && address.tel) {
          params.phone_number = address.tel
        }
        this.$router.push({
          path: "/ship_info",
          query: params,
        })
      },

      payOrder(order) {
        this.selectedOrderId = order.id;
        this.selectedOrderType = order.order_type;
        this.selectedOrderPrice = order.total_price * 100

        let fullUrl = window.location.href
        fullUrl += (fullUrl.indexOf("?") === -1 ? "?" : "&");
        fullUrl += '_r_source=order_list&order_id=' + this.selectedOrderId
        this.callbackUrl = fullUrl
        this.selectedOrderAddr = order.address
        this.selectedOrderAddr.addressDetail = order.address.address_detail

        this.showConfirmPay = true
      },

      onCancelPay() {
        this.showConfirmPay = false
      },

      showPay(order) {
        if (order.status === "created") {
          return true
        } else {
          return false
        }
      },

      onClickMore(order) {
        this.showActions = true
      },

    },
    computed: {
      fullAddress() {
        if (!this.selectedOrderAddr) {
          return ""
        }

        return this.selectedOrderAddr.province + " " + this.selectedOrderAddr.city + " " + this.selectedOrderAddr.county + " " + this.selectedOrderAddr.address_detail
      }
    }
  };
</script>
<style lang="scss" scoped>
  .order-list-page{
    background: #f2f2f2;
    padding: 55px 12px 0;
  }

  .list-box {
    min-height: 100vh;
  }

  .list-box .list {
    overflow: hidden;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    border-radius: 8px;
    margin-top: 22px;
  }

  .list-box .list:first-child {
    margin-top: 0;
  }

  .order-item-group {
    margin-top: 2px;
    border-bottom: 1px solid #f2f2f2;
  }

  .order-footer {
    height: 50px;
    margin-top: 20px;
    text-align: center;
    font-size: 14px;
  }

  .tip {
    margin-top: 50px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: lightgray;
  }

  .tip-info {
    font-size: 12px;
    color: white;
    text-align: center;
  }

  .order-tag {
    margin-left: 12px;
  }

  .cell-info {
    font-size: 12px;
  }

  .addr-cell {
    color: grey;
  }

  .pay-container {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .desc-text {
    }

    .pay-btn {
      width: 45px;
    }

    .more-container {
      color: grey;
    }
  }

  .ship-cell-container {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .ship-info-button-container {
    }
  }

  .ship-cell {
    display: flex;
    align-items: flex-start;

    .info-div {
      margin-right: 15px;
    }
  }

  .empty-cell {
    color: grey;
  }

  .total-order-price-desc {
    margin-left: 15px;
  }

</style>
